





function   pick_elasticache_shape(regionInfo, config) {


// regionInfo.shapes = array of different Elasticache Shapes to consider
// config = details about the target values and other properties of the database




      //Now work on Elasticache
      // console.log("pick_elasticache_shape");

        var OrigelasticacheItems = regionInfo.shapes;
        
        // do we even look for an elasticache (is SGA bigger than minimum)
        if (config.Memory*1 < config.frozen_prefs.caching_minmem*1) {
          console.log("pick_elasticache_shape: not looking for elasticache because SGA is smaller than minimum ");
          return null;
        }
        
        var targetCacheMemory = config.Memory * 0.5 / 3;
        if (config.frozen_prefs.caching_algo=="ec25") targetCacheMemory = config.Memory * (0.25) / 3;
        if (config.frozen_prefs.caching_algo=="ec65") targetCacheMemory = config.Memory * (0.65) / 3;
        // console.log("targetCacheMemory = " + targetCacheMemory);

        function elasticacheCompareCost(a, b) {
          // Use toUpperCase() to ignore character casing
          var temp_UseRI = config.UseRI;
          // ignore Savings Plans for Elasticache for now
          if ( (temp_UseRI=="SP-Only") || (temp_UseRI=="RI+SP") || (temp_UseRI=="SP") ) {
             temp_UseRI="RI";
          }
          
          const itemA = ((temp_UseRI=='RI') && a.Elasticache1yrNURI * 1 > 0 ? a.Elasticache1yrNURI*1 : a.ElasticacheOD*1) * 10000 + a.ElasticacheMemory*1;
          const itemB = ((temp_UseRI=='RI') && b.Elasticache1yrNURI * 1 > 0 ? b.Elasticache1yrNURI*1 : b.ElasticacheOD*1) * 10000 + b.ElasticacheMemory*1;

          let comparison = 0;
          if (itemA > itemB) {
            comparison = 1;
          } else if (itemA < itemB) {
            comparison = -1;
          } else if (itemA == itemB) {
          // final sort is by Name in REVERSE order.  This should make r6i.xlarge appear ahead of r5.xlarge
            if (a.Name > b.Name) {
              comparison = -1;
            } else if (a.Name < b.Name) {
              comparison = 1;
            }
          }
          return comparison;
        }
        //filter out shapes that don 't have EC prices
        OrigelasticacheItems = OrigelasticacheItems.filter(function(item) {
          return item.ElasticacheOD * 1 > 0;
          }
          );
      var elasticacheItems = OrigelasticacheItems.sort(elasticacheCompareCost);
      // console.log(elasticacheItems);
      
      //Now work on Elasticache
      var elasticacheSelected = null;
      let closeness = -999;
      let closeness_string = "";
      let match_string = "";
      
      let gap_memory=  0;

      for (var bii = 0; bii < elasticacheItems.length; bii++) {
        
          // console.log("looping", elasticacheItems[bii].Name, elasticacheItems[bii].ElasticacheMemory, elasticacheItems[bii].ElasticacheOD );

       if (elasticacheItems[bii].ElasticacheOD*1>0) {
         // hard-code to allow T shapes.  

          // intentional, see comment above

          // eslint-disable-next-line no-constant-condition
          if ( ( true ||
            config.frozen_prefs.tshape_algo == "Y" ||
            elasticacheItems[bii].Name.substring(0, 1) != "t"
            )  )
          {
            
          match_string = `cache.${elasticacheItems[bii].Name} with ${elasticacheItems[bii].VCPU} VCPU, ${elasticacheItems[bii].ElasticacheMemory} GB`;
  
  // console.log("testing", match_string);
          
          if (
            elasticacheItems[bii].ElasticacheMemory * 1 >= targetCacheMemory * 1 
          ) {
            //check if we can use T shapes
            // console.log("substr: "+elasticacheItems[bii].Name.substring(0,4));
  
                elasticacheSelected = elasticacheItems[bii];
                // console.log("Submit: found elasticache match:"+elasticacheItems.Name)
                break;
                
            } else {
              //the shape was not selected.
              let new_closeness = 
                Math.min((elasticacheItems[bii].ElasticacheMemory * 1 - targetCacheMemory * 1 ) / elasticacheItems[bii].ElasticacheMemory,0)  ;

              
              if (new_closeness > closeness) {
                gap_memory=  Math.round((Math.max((targetCacheMemory * 1 ) - elasticacheItems[bii].ElasticacheMemory * 1 ,0))*10)/10;
                // closeness_string = `Next closest match: cache.${elasticacheItems[bii].Name} with ${elasticacheItems[bii].VCPU} VCPU, ${elasticacheItems[bii].Memory} GB`;
                closeness_string = `Next closest match: cache.${elasticacheItems[bii].Name} with ${elasticacheItems[bii].VCPU} VCPU, ${elasticacheItems[bii].ElasticacheMemory} GB${(gap_memory>0) ? " (short "+gap_memory+" GB)" : ""}`;
  
                closeness=new_closeness;
              }
            }
          }  
       } //end if (elasticacheItems[bii].ElasticacheOD*1>0) {  
      } //end loop
      

      // console.log(match_string);
      // console.log("RDS", closeness_string);
      if (elasticacheSelected==null) {
        elasticacheSelected = { Name: null};
      }

      elasticacheSelected.closeness_string = closeness_string;
      elasticacheSelected.match_string = match_string;
      elasticacheSelected.elasticache_gap_memory = gap_memory;
      elasticacheSelected.target_memory= targetCacheMemory;

      return elasticacheSelected;
    }





function   calculate_elasticache_config(regionInfo, elasticacheItemSelected, config) {

// **************************
// Elasticache Configuration
// **************************

// elasticacheItemSelected = a document contain specific rdsItem (shape) and its details, closeness_string, and match_string
// config = details about the target values and other properties of the database




      // Step 2 - prepare additional fields describing the configuration 
      
      
            //TODO hard code backup for now
      config.BackupType = 'none';
      config.Backup = '0';
      config.SnapshotDays = '1';


      if ((elasticacheItemSelected.Name == null)) {
        //if rds_shape==N/A, then don't pick an Elasticache shape either
        // console.log("Submit: No matching Elasticache found for "+ config.database)
        // config.iomb_warnings = "Y";
        config.elasticache_shape = "N/A";
        config.targetconfig_elasticache = {
          summaryText: "DBCSI's current logic is not able to auto-size this configuration for Elasticache. Please reach out to your AWS Database Specialist for help.",
          monthly_estimate: "null",        
          shape: "null",
          shape_OD: "null",
          shape_RI: "null",
          shape_max_vcpu: "null",
          shape_memory: "null",
          requested_memory: "null",
          shape_throughput: "null",
          shape_summaryText: "",
          comments: "",
          warnings: "No matching shape found",
          closeness_string: elasticacheItemSelected.closeness_string,
          match_string: ""
          
        }            ;
      } else
      {


        // Step 2b - This is a fit.  So, describe it
        

      var tempConfig = {
        summaryText: "Select an Elasticache Shape to continue...",
        monthly_estimate: "null",
        shape: "null",
        shape_OD: "null",
        shape_RI: "null",
        shape_max_vcpu: "null",
        shape_memory: "null",
        requested_memory: "null",
        shape_throughput: "null",
        shape_summaryText: "",
        shape_cost: "",
        comments: "",
        UseMAZ: "No"
      };


      tempConfig.shape = elasticacheItemSelected.Name;
      tempConfig.shape_OD = elasticacheItemSelected.ElasticacheOD;
      tempConfig.shape_RI = elasticacheItemSelected.Elasticache1yrNURI;
      tempConfig.shape_max_vcpu = elasticacheItemSelected.VCPU;
      tempConfig.requested_memory = elasticacheItemSelected.target_memory;
      tempConfig.shape_memory = elasticacheItemSelected.ElasticacheMemory;
      tempConfig.shape_throughput = elasticacheItemSelected.Throughput;
      tempConfig.shape_network = elasticacheItemSelected.Network;
      tempConfig.shape_baseline_network = elasticacheItemSelected.baseline_Network;
    // tempConfig.comments = this.comments.Elasticache;
      if (typeof tempConfig.comments === "undefined") {
        tempConfig.comments = "";
      }
      tempConfig.UseMAZ = config.UseMAZ;
      tempConfig.RIused="OD";

      
      if (1 * tempConfig.requested_memory > 1 * tempConfig.shape_memory) {
        tempConfig.cpu_warnings =
          tempConfig.cpu_warnings +
          "The shape " +
          tempConfig.shape +
          " does not have " +
          tempConfig.requested_memory +
          " GB of memory. ";
      }
      
      
     var temp_UseRI = config.UseRI;
     // ignore Savings Plans for Elasticache for now
     if ( (temp_UseRI=="SP-Only") || (temp_UseRI=="RI+SP") || (temp_UseRI=="SP") ) {
       temp_UseRI="RI";
     }

      var shapeCost = 0;
      var mazString = "";
      var mazFactor = 1.0;
      if (tempConfig.UseMAZ=="Yes") {
        mazString=" (2 instances: Primary and Replica)";
        mazFactor = 2.0;
      }
      if ((temp_UseRI=='RI') && tempConfig.shape_RI > 0) {
        shapeCost = tempConfig.shape_RI * 730 * mazFactor;
        tempConfig.shape_summaryText = "Elasticache Compute";
        

         tempConfig.shape_summaryText += mazString+" Monthly estimate (using 1-year Reserved Instance pricing for Elasticache): $" +
          shapeCost.toFixed(2);
        tempConfig.RIused="RI";
      } else {
        shapeCost = tempConfig.shape_OD * 730 * mazFactor;
        tempConfig.shape_summaryText = "Elasticache Compute";


        tempConfig.shape_summaryText += mazString+" Monthly estimate (using On-Demand pricing for Elasticache): $" +
          shapeCost.toFixed(2);
      }
      tempConfig.shape_cost = shapeCost;


      var tempCost = shapeCost ;

       tempConfig.summaryText =
          "Elasticache"+mazString+" Monthly = [" + (tempConfig.UseMAZ=="Yes" ? "2xcache." : "cache.") +
          elasticacheItemSelected.Name +
          "]" +
          " = $" +
          (tempCost).toFixed(2);
       

      tempConfig.monthly_estimate=Math.round(tempCost*100)/100;



        
        var target_elasticache = tempConfig;
        // console.log("Submit: elasticache=" + target_elasticache.summaryText);
        // config.elasticache_shape = target_elasticache.shape;
        config.targetconfig_elasticache = target_elasticache;
        config.targetconfig_elasticache.closeness_string = elasticacheItemSelected.closeness_string;
        config.targetconfig_elasticache.match_string = elasticacheItemSelected.match_string;
        
        //set Adjusted target values based on algos
        var adjustRatio = 0.5;
        if (config.frozen_prefs.caching_algo=="ec25") adjustRatio = 0.25;
        if (config.frozen_prefs.caching_algo=="ec65") adjustRatio = 0.65;
        config.AdjustedVCPU = Math.round(config.VCPU * (1-adjustRatio) * 10)/10;
        config.AdjustedMemory = Math.round(config.Memory * (1 - adjustRatio));
        config.AdjustedIOPS = Math.round(config.IOPS * (1 - adjustRatio));
        config.AdjustedThroughput = Math.round(config.Throughput * (1 - adjustRatio));
        config.targetconfig_elasticache.elasticache_assumptions = "Reduce RDS requirements by " + (adjustRatio*100) + "%.  Size ElastiCache based on 1:3 ratio to SGA reduction.";
        
      }



      return config;
    }


export {pick_elasticache_shape};

export {calculate_elasticache_config};